import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['frame']
  static classes = ['autocompleting']

  static values = {
    url: String,
    delay: { type: Number, default: 300 },
    invalid: Boolean
  }

  #timer = null

  input({ detail: { value } }) {
    this.invalidValue = false

    clearTimeout(this.#timer)

    this.#timer = setTimeout(() => {
      this.#search(value)
    }, this.delayValue)
  }

  toggle() {
    (this.frameTarget.innerHTML.length > 0) ? this.#open() : this.#close()
  }

  handleInvalid() {
    this.invalidValue = true
    this.toggle()
  }

  closeOnClickOutside({ target }) {
    if (this.invalidValue || this.element.contains(target)) return

    this.#close()
  }

  #search(query) {
    const cleaned = query.trim()

    if (cleaned === '') {
      this.frameTarget.innerHTML = ''
      this.#close()
      return
    }

    const url = new URL(this.urlValue, location)
    url.searchParams.set('q', cleaned)

    this.frameTarget.src = url
  }

  #open() {
    this.frameTarget.classList.add(this.autocompletingClass)
  }

  #close() {
    this.frameTarget.classList.remove(this.autocompletingClass)
  }
}
